import { Component, TemplateRef} from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { SweetServices } from 'src/services/sweet.services';
import { AppComponent } from '../app.component';
import { LoginService } from '../../services/login/login.service';
import { User } from '../model/session/user.model';
import { SessionSotrageService } from '../../services/session-sotrage.service';
import { ComunicacionService } from '../../services/comunicacion.service';
import { HomeService } from 'src/services/home/home.service';
import { Helper } from 'src/app/common/Helper/Helper';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {
  selectedLanguage = environment.lang;
  public lang: string = environment.lang;
  public loadingTemplate: TemplateRef<any>;

  public traduccion = environment.traduccion;

  loginForm = {
    Login: '',
    Password: '',
    Bloqueo: false,
    version: environment.version
  };

  public appdata:any;

  env:string;
  backgroundStyle: any = {};

  constructor(private translateService: TranslateService,
              private router: Router,
              private alerta: SweetServices,
              private appLoading: AppComponent,
              private loginService: LoginService,
              private ssservice: SessionSotrageService,
              private comunicacionService: ComunicacionService,
              private homeService: HomeService,
              private Helpers: Helper) {
    this.translateService.setDefaultLang(this.selectedLanguage);
    const browserLang = translateService.getBrowserLang();
    translateService.use(browserLang.match(/es|en|fr|pt/) ? browserLang : this.selectedLanguage);
    translateService.use(this.selectedLanguage);
    this.comunicacionService.setLenguaje(this.selectedLanguage);

    this.appdata = this.homeService.getEnvironment();
    this.env = this.appdata === null ? "texto" : this.appdata.licenseData.customer.isProduction ? '' 
      : this.appdata.licenseData.customer.customerName + ' ' + this.appdata.licenseData.customer.environment;
    
    this.updateBackgroundStyle();
  }

  //Tener en cuenta más adelante formLogin al no usarse
  submitLogin(formLogin: NgForm) {
    this.appLoading.loading = true;
    if (this.loginForm.Login === '' || this.loginForm.Password === '') {
      this.appLoading.loading = false;
      this.alerta.AlertaErrorTimer('Llena el Formulario');
    } else {
      this.loginService.iniciarSesion(this.loginForm).subscribe(response => {
        if (response === null) {
          this.appLoading.loading = false;
          this.alerta.AlertaError(
            'Existe un error, si persiste contacte al administrador del Sitio.'
          );
        } else if (response.isCorrect === 'false') {
          this.appLoading.loading = false;
          this.alerta.AlertaError(response.message);
        } else {
          this.ssservice.setPasswordSession(this.loginForm.Password);
          this.correctLogin(response.data.info.result);
        }
      }, (err) => {
        this.appLoading.loading = false;
        this.alerta.AlertaCatch(err);
      }
      );
    }

  }

  private correctLogin(data: User) {
    this.ssservice.setCurrentSession(data);
    var message = data.recordatorioCaducidad? data.mensajeCaducidad:'';
    var header = data.recordatorioCaducidad 
      ? 'Actualizar contraseña'
      :'Ingrese su nueva contraseña';
    var confirmMessage = data.recordatorioCaducidad 
      ? 'Acceso Confirmado...'
      :'Operación realizada con éxito.';
    if (data.primeraVez) {
      this.appLoading.loading = false;
      this.alerta.AlertaCambioPassword(
        data.usuarioId, 
        this.router, 
        message, 
        header, 
        confirmMessage
      );
    } else if(data.recordatorioCaducidad){
      this.appLoading.loading = false;
      this.router.navigate(['/v2']);
      this.alerta.AlertaCambioPassword(
        data.usuarioId, 
        this.router, 
        message, 
        header, 
        confirmMessage
      );
    }else {
      this.router.navigate(['/v2']);
    }
  }

  toogleLanguage(lang: string) {
    this.translateService.use(lang);
    this.lang = lang;
    this.comunicacionService.setLenguaje(lang);
  }

  updateBackgroundStyle() {
    this.backgroundStyle = this.Helpers.updateBackgroundStyle(this.env);  
  }  
}
